export const ENDPOINTS = {
  SIGN_IN_WITH_EMAIL: '/sign-in/email',
  // Registered as `/user/sign-out`, unlike sign-in / sign-up which sit at the
  // root. `/sign-out` matched no route, so signing out has been a silent 404.
  SIGN_OUT: '/user/sign-out',
  SIGN_UP_WITH_EMAIL: '/sign-up/email',
  TODO_WITH_ID: '/todo/:id([a-z0-9-.]+)',
  WS_ECHO: '/ws/echo',
  INFLUENCERS: '/influencer/list',
  INFLUENCER_COUNT: '/influencer/count',
  INFLUENCER_UPDATE: '/influencer/update/:influencerId',
  GET_ORGANIZATION_ASSIGNED: '/influencer/getOrg/Assigned/:id',
  GET_POOl_ASSIGNED: '/pool/assigned/:id',
  REMOVE_FROM_ORGANIZATION: '/influencer/removeOrg/:influencerId/:orgId',
  SWITCH_INFLUENCER_ORGANIZATION_ORG: '/influencer/switchOrgStatus',
  TAGS_GET: '/tag/list',
  ASSIGN_TAGS: '/tag/assign',
  CREATE_TAGS: '/tag/add-bulk',
  MARK_ACTIVE: '/tag/state',
  GET_ORGANIZATION: '/get/organizations',
  UPDATE_MODULES: '/organizations/update-modules',
  ORG_ADD_USER: '/organization/add-user',
  ASSIGN_ORG: '/assign/organization',
  CREATE_POOL: '/pool/add',
  GET_POOL: '/pool/list',
  ASSIGN_POOl: '/pool/assign-influencer',
  REMOVE_CREATOR_FROM_POOL: '/pool/remove-influencer',
  GET_POOL_DETAIL: '/pool/detail/:id',
  ACTIVATE_POOL: '/pool/activate',
  BRAND_GET: '/brand/list',
  BRAND_CHANGE_ACTIVE_STATUS: '/brand/change-active-status',
  // Registered as `GET /user` (adminUser.all). `/user/list` matched no route,
  // so the admin users page has been fetching a 404.
  GET_USERS: '/user',
  FORCE_LOGOUT: '/user/force-logout',
  EMAIL_STAGES_LIST: '/email-stages/list',
  // EMAIL_STAGES_BY_ID / EMAIL_STAGES_BY_ORG removed: neither route exists on
  // the admin API — it serves only `/email-stages/{list,add,edit/:id,
  // delete/:id}` — and nothing called them. They were a 404 waiting for a
  // caller. Filtering is done through `list`, which takes query params.
  CONTENT_LIBRARY_ANALYTICS: '/analytics/content-library',
} as const;

export type Endpoints = typeof ENDPOINTS;
